import React from "react";

const Footer = () => {
  return (
    <footer className="text-xs text-gray-400 text-center py-6 border-t mt-12">
      © 2025 Seratics.
    </footer>
  );
};

export default Footer;
